import { Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommsService } from '../../services/comms/comms.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { DisplayService } from '../../services/display/display.service';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { HelpService } from '../../services/help/help.service';
import { NoteService } from '../../services/note/note.service';
import { DataTableService } from '../../services/dataTable/dataTable.service';

import { TabService } from '../../services/tab/tab.service';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';


@Component({
	selector: 'pcm-page-supplier-invoices',
	templateUrl: './page-supplier-invoices.component.html',
	styleUrls: ['./page-supplier-invoices.component.scss']
})
export class PageSupplierInvoicesComponent implements OnInit, OnDestroy {

	@ViewChild('modalForm') modalForm;

	title = 'Supplier Invoices';
	objRoot = 'supplier-invoice';
	dataObj = this.invoiceService.supDataObj;
	scDataObj;
	activeModal = '';
	pending = '';
	selectionType = 'checkbox';
	modalVisible = false;
	actions = [];
	pendingActions = [];
	archivedActions = [];
	showExportModal = false;
	columnsConfig = [];
	clickedRow;

	jrSteps = [];
	jrStepIDs = [];

	initTab = '';

	defaultSort = [
		{
			prop: this.configService.invoiceChaincodeProp + '.' + this.configService.invoiceDateProp,
			dir: 'desc'
		}
	];

	userSettingsListener;
	currentEvent = '';
	

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private commsService: CommsService,
		public configService: ConfigService,
		private dataService: DataService,
		private displayService: DisplayService,
		public helpService: HelpService,
		public invoiceService: InvoiceService,
		private noteService: NoteService,
		private tabService: TabService,
		private dataTableService: DataTableService,
		private smartContractService: SmartContractService,
	) {
	}

	ngOnInit() {
		this.columnsConfig = this.configService.getTableFields(this.dataObj, false);
		this.actions = this.configService.getActions(this.dataObj);
		if (this.actions.length === 0) {
			this.actions.push(this.configService.getExportAction());
		}

		this.pendingActions = this.configService.getActions('pendingsupplierinvoice');
		if (this.pendingActions.length === 0) {
			this.pendingActions.push(this.configService.getExportAction());
		}

		this.archivedActions = this.configService.getActions('archivedsupplierinvoice');
		if (this.archivedActions.length === 0) {
			this.archivedActions.push(this.configService.getExportAction());
		}

		this.invoiceService.supDataConfig = this.configService.getDataObj(this.dataObj);
		this.displayService.clearLoading();
		this.helpService.supplier_invoices.forEach(step => {
			this.jrSteps.push(step);
			this.jrStepIDs.push(step.id);
		});

		this.route.params.subscribe(params => {
			this.initTab = params['initTab'];
			this.tabService.loadTab(this.invoiceService.tabsData.supListTabs, this.invoiceService, this.initTab);
		});

		this.userSettingsListener = this.dataService.userSettingsListener().subscribe((event) => {
			this.tabService.loadTab(this.invoiceService.tabsData.supListTabs, this.invoiceService, this.initTab);
		});

		// BCL-1902: un-comment this call to loadRejectReasons() to make reject reasons available for modal
		this.invoiceService.loadRejectReasons();
	}

	ngOnDestroy() {
		this.userSettingsListener.unsubscribe();
	}

	getActionsForTab() {
		const tab = this.invoiceService.getActiveTab(this.invoiceService.tabsData.supListTabs).prop;
		if (tab === 'pending') {
			return this.pendingActions;
		} else if (tab === 'inactive') {
			return this.archivedActions;
		} else {
			return this.actions;
		}
	}

	allowAction = () => {
		return this.dataService.selectedTableRows[0] !== undefined;
	}

	takeAction(event) {
		console.log('TAKE ACTION', event);
		this.currentEvent = event.action.prop;
		if (event.action.prop === 'supplierinvoicearchive') {
			this.archiveInvoices(true);
		} else if (event.action.prop === 'supplierinvoiceactivate') {
			this.archiveInvoices(false);
		} else if (event.action.prop === 'exporttocsv') {
			this.showExportModal = true;
		} else if (event.action.prop === 'supplierinvoicereject') {
			this.modalForm.showModal(event.action, this.configService.supplierInvoiceSCDataObj, this.dataService.selectedTableRows);
		}
	}

	modalSubmit(event) {
		console.log('MODAL SUBMIT', event);
		this.smartContractService.submitSmartContract(
			{
				invoicenumbers: event.data.supplierinvoices.map(obj => obj.invoicenumber),
				rejectreason: event.data.rejectreasons,
			},
			event.prop, 
			this
		);
		this.modalForm.formCancel();
	}

	archiveInvoices(archive) {
		const invoices = [];
		this.dataService.selectedTableRows.forEach((row) => {
			const invoice = {
				ponumber: row.ponumber,
				supplierid: row.supplierid,
				invoicenumber: row.invoicenumber
			};
			invoices.push(invoice);
		});

		console.log('ARCHIVE INVOICES', invoices);
		this.invoiceService.archiveInvoices(invoices, archive, this);
	}

	successCall() {
		this.dataService.clearSelectedTableRows();
		this.dataService.broadcastNotifications(this.dataObj);
		if (this.currentEvent === 'supplierinvoicereject') {
			setTimeout(() => {
				const activeTab = this.invoiceService.getActiveTab(this.invoiceService.tabsData.supListTabs);
				this.invoiceService.selectActiveTab(this.invoiceService.tabsData.supListTabs, activeTab['prop']);
			}, 1000);
		}
	}

	errorCall(res) {
		this.noteService.displayError('Failed to process the selected supplier invoices');
		console.log('BULK SUPPLIER INVOICES ERROR');
		this.handlePartialSuccess(res);
	}

	partialCall(res) {
		this.noteService.displayError('Failed to process some or all supplier invoice rejection requests');
		console.log('BULK INVOICES PARTIAL');
		this.handlePartialSuccess(res);
	}

	handlePartialSuccess(res) {
		this.invoiceService.handlePartialSuccess(res);
		const tabs = this.invoiceService.tabsData.listTabs;
		this.invoiceService.selectActiveTab(tabs, this.invoiceService.getActiveTab(tabs)['props']);
	}

	tableClick(event) {
		const clickedRow = event.row;
		const poNumber = clickedRow[this.configService.poNumberProp];
		const invoiceNumber = clickedRow[this.configService.invoiceNumberProp];
		const supplierId = clickedRow[this.configService.supplierIdProp];
		this.openSupplierInvoice(poNumber, invoiceNumber, supplierId);
	}

	openSupplierInvoice(poNumber, invoiceNumber, supplierId) {
		this.router.navigateByUrl(this.objRoot + '/' + poNumber + '/' + invoiceNumber + '/' + supplierId);
	}

	tablePage(event) {
		const activeTab = this.invoiceService.getActiveTab(this.invoiceService.tabsData.supListTabs);
		activeTab['page'] = event.offset;
		this.invoiceService.loadInvoicesForTab(activeTab);
	}

	tableSort(event) {
		this.dataTableService.tableSort(
			event,
			this.invoiceService.getActiveTab(this.invoiceService.tabsData.supListTabs), (tab) => this.invoiceService.loadInvoicesForTab(tab)
		);
	}

	tableSearch(event) {
		const activeTab = this.invoiceService.getActiveTab(this.invoiceService.tabsData.supListTabs);
		this.invoiceService.loadInvoicesForTab(activeTab);
	}

	tableRefresh(event) {
		console.log('SUPPLIER INVOICE TABLE REFRESH: ', event);
		this.invoiceService.rowsPerSupplierPage = event.data.rowsPerPage;
		const tabs = this.invoiceService.tabsData.supListTabs;
		tabs.forEach(tab => {
			tab['pageSize'] = this.invoiceService.rowsPerSupplierPage;
		});
		this.invoiceService.loadInvoicesForTab(this.invoiceService.getActiveTab(tabs));
	}

	closeExportModal() {
		this.showExportModal = false;
	}

	exportToCSV(event) {
		this.commsService.exportToCSV(event.data, this.configService.getTableFields(this.dataObj, false), this.dataService.selectedTableRows);
		const self = this;
		const delay = setTimeout(function () {
			self.closeExportModal();
		}, 1000);
	}
}

